var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnWaermepumpe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.83 43.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#4b4a4a;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.7px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.85,
    y: 0.85,
    width: 54.13,
    height: 41.97,
    rx: 2.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 19.87,
    cy: 21.88,
    r: 13.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.36 8.85h9.67M39.36 14.06h9.67M39.36 19.28h9.67M39.36 24.49h9.67M39.36 29.7h9.67M39.36 34.92h9.67M20.83 25.41a6.8 6.8 0 0 1-.25 3.16 3.71 3.71 0 0 1-3.89 2.57 6.59 6.59 0 0 1-2.91-.88 9.33 9.33 0 0 1-3.45-3 2.94 2.94 0 0 1-.5-1.73 2.16 2.16 0 0 1 1.65-2 7.44 7.44 0 0 1 2.52-.42c.78 0 1.56-.06 2.33-.07a.3.3 0 0 1 .23.14 3.83 3.83 0 0 0 3.25 2.23c.29.03.64 0 1.02 0zM16.33 21a6.78 6.78 0 0 1-2.62-1.79 3.71 3.71 0 0 1-.27-4.66 6.59 6.59 0 0 1 2.22-2.08A9.5 9.5 0 0 1 20 10.93a3 3 0 0 1 1.75.44 2.17 2.17 0 0 1 .91 2.43 7.43 7.43 0 0 1-.88 2.35c-.36.69-.73 1.37-1.11 2.05a.26.26 0 0 1-.23.13A3.84 3.84 0 0 0 16.86 20c-.19.31-.34.62-.53 1zM22.44 19.28a7 7 0 0 1 2.86-1.36A3.7 3.7 0 0 1 29.47 20a6.47 6.47 0 0 1 .69 3 9.36 9.36 0 0 1-.87 4.48A2.86 2.86 0 0 1 28 28.75a2.17 2.17 0 0 1-2.56-.42 7.64 7.64 0 0 1-1.6-1.94c-.41-.66-.82-1.32-1.22-2a.29.29 0 0 1 0-.27 3.81 3.81 0 0 0 .3-3.93c-.09-.29-.29-.58-.48-.91zM19.88 21a.84.84 0 0 1 .83.87.85.85 0 1 1-.83-.87z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWaermepumpe);
export default __webpack_public_path__ + "static/media/icn-waermepumpe.06a60602156c2bd6a0f75f4373f65de3.svg";
export { ForwardRef as ReactComponent };